import React from 'react';
import meetingStyles from './index.module.css';
import Grid from '@material-ui/core/Grid';


class BookAMeeting extends React.Component {
  render() {
    return (
      <Grid container className={meetingStyles.mainSectionBottomMeetingContainer}>
        <Grid item xs={12}>
          <div className={`${meetingStyles.articleTitle} articleTitle`}>Book a Meeting</div>
        </Grid>
        <Grid item xs={12} className={meetingStyles.infoTitle}>
          Email
        </Grid>
        <Grid item xs={12} className={meetingStyles.infoContent}>
          <a href="mailto:info@mimosa.solutions" className={meetingStyles.emailLink}>
            info@mimosa.solutions
          </a>
        </Grid>
      </Grid>
    );
  }
}

export default BookAMeeting;